export { default } from './masthead';
